export { ProductName } from "@hooks/useMemberUser";
export { MemberProductLevelEnum } from "@features/api/memberApi";
import { MemberProductLevelEnum } from "@features/api/memberApi";

// type: FREE, TRIAL, NORMAL, REWARD
export enum ProductType {
  TRIAL = "TRIAL",
  NORMAL = "NORMAL",
}

export const ProductLevelType = {
  [MemberProductLevelEnum.EXPERT]: "Expert",
  [MemberProductLevelEnum.PRO]: "Pro",
  [MemberProductLevelEnum.FREE]: "Free",
} as const;

export enum ProductPayCycle {
  MONTH = "MONTH",
  YEAR = "YEAR",
  WEEK = "WEEK",
  LIFETIME = "LIFETIME",
}

export enum ProductStatus {
  ACTIVE = "ACTIVE",
}

export enum ProductPlanStatus {
  ACTIVE = "ACTIVE",
}
